import { updateRemoteSession } from '../services/conversationStore';

/**
 * Record which project a conversation belongs to, in one attempt.
 *
 * Called after the generate stream has ended, when the session row exists on
 * the server. It used to be fired the moment the session was created locally
 * as well, with five attempts: the row was not there yet, so every new
 * conversation opened with a 404 and four more requests for the same 404
 * (I-010). A failure is logged, never thrown, and never retried; the caller
 * is a fire-and-forget after the stream.
 */
export async function persistProjectScope(sessionId: string, projectId: string): Promise<void> {
  try {
    await updateRemoteSession(sessionId, { projectId } as any);
  } catch (error) {
    console.warn('[projects] Failed to persist project scope for session', sessionId, error);
  }
}
